module.exports = __webpack_public_path__ + "img/trol5.5.3d585caa.png";